module.exports = __webpack_public_path__ + "img/siracusacosta.fefc6a12.png";